import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RequestService } from 'src/app/services/request/request.service';

@Component({
  selector: 'app-profile-song-picker',
  templateUrl: './profile-song-picker.component.html',
  styleUrls: ['./profile-song-picker.component.scss'],
})
export class ProfileSongPickerComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @Input() embedded = false;
  @Input() initialQuery = '';
  @Input() preloadedTracks: any[] = [];
  @Output() trackAdded = new EventEmitter<any[]>();
  query = '';
  tracks: any[] = [];
  searching = false;
  addingTrackId = '';

  constructor(
    private modalController: ModalController,
    private request: RequestService,
  ) {}

  ngOnInit(): void {
    this.applyInitialData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialQuery || changes.preloadedTracks) this.applyInitialData();
  }

  private applyInitialData(): void {
    if (this.initialQuery && !this.query) this.query = this.initialQuery;
    if (Array.isArray(this.preloadedTracks) && this.preloadedTracks.length) {
      this.tracks = this.preloadedTracks;
    }
  }

  close(tracks?: any[]): void {
    if (this.embedded) {
      if (tracks) this.trackAdded.emit(tracks);
      return;
    }
    this.modalController.dismiss({ tracks });
  }

  search(): void {
    const text = this.query.trim();
    if (!text || this.searching) return;
    this.searching = true;
    this.request.createRequestPost('spotify_search', { text, market: 'MX' })
      .then((raw: any) => {
        const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        this.tracks = data?.data?.tracks?.items || [];
      })
      .catch((error) => console.error('LK Music search failed.', error))
      .finally(() => this.searching = false);
  }

  addTrack(track: any): void {
    if (!track?.id || this.addingTrackId) return;
    this.addingTrackId = track.id;
    this.request.createRequestPost('profile_music_playlist_auth', {
      profile_id: this.profileId,
      track,
    }).then((raw: any) => {
      const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      this.close(Array.isArray(data?.tracks) ? data.tracks : undefined);
    }).catch((error) => {
      console.error('Unable to add profile song.', error);
    }).finally(() => this.addingTrackId = '');
  }

  artwork(track: any): string {
    return track?.album?.images?.[0]?.url || 'assets/icon/logo-dark.svg';
  }
}
